import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {
    Column,
    ConfiguratorTableService,
    Constraint,
    EngineDataQueryService,
    FieldTableDto,
    ObjectQuery,
    ObjectQueryFilter,
    Table,
    TableJointure
} from '@tj/tj-dmp-lib-api';
import {QueryFactoryService} from '../query-factory.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dmp-expand-data-section',
    templateUrl: './expand-data-section.component.html',
    styleUrls: ['./expand-data-section.component.scss'],
    standalone: false
})
export class ExpandDataSectionComponent implements OnChanges {

    /** table à charger */
    @Input() table: TableJointure;
    @Input() valueConstraint: any;
    @Input() tenant;

    /** etat de chargement de l'écran */
    loading = true;
    /** affichage des résultats */
    display = false;
    /** liste des codes tables */
    codeTables: string[] = [];

    /** pagination */
    paginator = {
        pageSize: 10,
        start: 0
    };
    /** nombre de résultat présent en base */
    totalRecords = 0;
    /** ligne des données */
    rowsData: Array<any> = [];
  /** description des table */
  descriptionsTables: any;
  tablesDescription: Table[] = [];


  constructor(
      protected tableResourceService: ConfiguratorTableService,
      protected engineDataQueryService: EngineDataQueryService,
      protected queryFactoryService: QueryFactoryService) {
      this.descriptionsTables = {
          first: null,
          end: null,
          list: null,
      };
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.metadata();
  }

  metadata() {
      if (this.tenant && this.table.tableName) {
          // liste les codes des tables
          this.codeTables = [this.table.tableName];
          const codeLastTable = this.setTableRecursif(this.table.join);
          // récupération de la description des tables
          this.tableResourceService.getTablesUsingGET(this.tenant, this.codeTables).subscribe(result => {
              this.descriptionsTables.first = result.find(f => f.code === this.table.tableName);
              this.descriptionsTables.last = result.find(f => f.code === codeLastTable);
              this.descriptionsTables.list = result;
              this.descriptionsTables.list.forEach(t => {
                  t.fields = ((t.fields) as Array<FieldTableDto>).filter(f => f.code !== 'id' && !f.code.startsWith('id_'));
              });
              this.query();
          });
      }
  }

  query() {

      const constraint: Constraint = this.queryFactoryService.comparison({
          table: this.table.tableName,
          code: 'id_personal_owner',
          categoryField: 'NUMBER'
      } as FieldTableDto, 'EQUALS', this.valueConstraint);

      const columns: Column[] = [];
      this.tablesDescription.forEach(t => {
          t.fields.forEach(f => {
              columns.push({
                  propertyName: f.code,
                  tableName: t.code,
                  schema: t.schema ? t.schema : this.tenant
              } as Column);
          });
      });

      const query: ObjectQuery = {
          table: this.table,
          clazz: 'ObjectQuery',
          columns,
          constraint
      };

      this.display = false;
      this.loading = true;
      const objectQueryFilter: ObjectQueryFilter = {
          constraint: query.constraint
      };
      this.engineDataQueryService.getQueryDataByTableUsingPOST(this.table.schema, this.paginator.start, objectQueryFilter,
          this.paginator.pageSize, this.table.tableName, 'response')
          // this.queryService.sendQuery(this.table.schema, query, this.paginator.start, this.paginator.pageSize)
          .subscribe(data => {
              this.totalRecords = +data.headers.get('x-total-count');
              this.rowsData = [];
              for (const rowData of data.body) {
                  this.rowsData.push(rowData.rows);
              }
              if (this.rowsData.length > 0) {
                  this.display = true;
              }
              this.loading = false;
          });
  }

  getData(rowData, field) {
      return rowData[field.code];
  }

  /**
   * alimente le tableaux des codes des tables
   * @param tables liste des jointures de tables
   * @returns le dernier code de la hiérarchie de table
   */
  protected setTableRecursif(tables: Array<TableJointure>): string {
    let lastCode = null;
    if (tables) {
      tables.forEach(j => {
        this.codeTables.push(j.tableName);
        const lastCodeContext = this.setTableRecursif(j.join);
        if (lastCodeContext) {
          lastCode = lastCodeContext;
        }
      });
    }
    return lastCode;
  }

}
